export const hospitalEncounterColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'admit_date',
  'admit_location',
  'admit_source_code',
  'admit_source_name',
  'admit_type_code',
  'admit_type_name',
  'admitting_physician_phone',
  'attending_physician_code',
  'attending_physician_name',
  'attending_physician_npi',
  'charity_care_flag',
  'charity_care_level',
  'code_complete_date',
  'coding_status_code',
  'coding_status_name',
  'combined_accounts__combined_date',
  'combined_accounts__source_account_number',
  'combined_accounts__target_account_number',
  'discharge_date',
  'discharge_department',
  'discharge_department_code',
  'discharge_disposition',
  'discharge_disposition_description',
  'discharge_facility',
  'ecd_number',
  'free_text_admitting_cpt',
  'free_text_admitting_dx',
  'guarantor_account_type',
  'guarantor_return_identifiers1',
  'guarantor_return_identifiers2',
  'guarantor_return_identifiers3',
  'hospital_service_type',
  'hospital_service_type_description',
  'initial_inpatient_visit_date',
  'institutional_flag',
  'is_op_recurring_visit',
  'mother_account_number',
  'patient_class',
  'patient_class_name',
  'patient_control_number',
  'patient_type_code',
  'patient_type_name',
  'reason_for_visit',
  'recurring_indicator',
  'referring_physician_code',
  'referring_physician_name',
  'referring_physician_npi',
  'referring_physician_phone',
  'registration_id',
  'research_flag',
  'return_from_agency_amount',
  'return_from_agency_date',
  'secondary_account_identifier',
  'secondary_visit_description',
  'snapshot_id',
  'transfer_to_agency_amount',
  'visit_description',
  'visit_grouping_unique_identifier',
  'visit_return_identifiers1',
  'visit_return_identifiers2',
  'visit_return_identifiers3',
];
